export const SESSION_PROGRESS_TAG = "SessionProgress";
